import dynamic from 'next/dynamic';

// Client-only: react-player/lazy suspends during SSR, which makes hydration of
// this page fail intermittently ("Hydration failed ... Suspense").
const ReactPlayer = dynamic(() => import('react-player/lazy'), { ssr: false });

//styles
import {
  VideoHeroWrapper,
  ContainerStyled,
  VideoContainer,
} from './VideoHero.styles';

export function VideoHero({
  url = 'https://www.youtube.com/watch?v=M2yaGJh3Q-U?rel=0',
}) {
  return (
    <VideoHeroWrapper>
      <ContainerStyled>
        <VideoContainer>
          <ReactPlayer
            className="react-player"
            url={url}
            controls
            width="100%"
            height="100%"
          />
        </VideoContainer>
      </ContainerStyled>
    </VideoHeroWrapper>
  );
}
